import { Button, ButtonProps, Typography } from "@mui/material";
import { ReactElement } from "react";
// eslint-disable-next-line no-restricted-imports
import { Link, LinkProps } from "react-router-dom";

export const BUTTON_WIDTH = "100px";

export function ActionButton(
  props: Omit<ButtonProps, "onClick"> & LinkProps
): ReactElement {
  const { sx, children, to, onClick, ...otherProps } = props;

  return (
    <Link to={to} onClick={onClick}>
      <Button
        variant="contained"
        sx={{ width: BUTTON_WIDTH, height: "27px", ...sx }}
        component="div"
        role="none"
        tabIndex={-1}
        {...otherProps}
      >
        <Typography variant="h4Caps">{children}</Typography>
      </Button>
    </Link>
  );
}
